import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { LogIn, Lock } from "lucide-react";
import { toast } from "sonner";
import { api, setToken } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent } from "@/components/ui/card";

export default function AdminLogin() {
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setToken(data.access_token);
      toast.success("Welcome back");
      nav("/admin", { replace: true });
    } catch (err) {
      const d = err?.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <Link to="/" className="text-xs uppercase tracking-[0.3em] text-muted-foreground hover:text-primary" data-testid="back-home">
          ← Back to store
        </Link>
        <Card className="mt-6 border-border shadow-none">
          <CardContent className="p-8">
            <div className="flex items-center gap-3 mb-6">
              <div className="h-10 w-10 rounded-sm gold-grad flex items-center justify-center"><Lock className="h-5 w-5 text-white" /></div>
              <div>
                <h1 className="font-serif text-2xl text-foreground">Admin Sign In</h1>
                <p className="text-xs uppercase tracking-[0.2em] text-muted-foreground">SSVJ Store Owner</p>
              </div>
            </div>
            <form onSubmit={submit} className="space-y-4" data-testid="admin-login-form">
              <div>
                <Label htmlFor="email">Email</Label>
                <Input id="email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="login-email" placeholder="admin@ssvj.com" />
              </div>
              <div>
                <Label htmlFor="password">Password</Label>
                <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="login-password" />
              </div>
              <Button type="submit" disabled={loading} className="w-full rounded-sm bg-primary hover:bg-primary/90" data-testid="login-submit">
                <LogIn className="h-4 w-4 mr-2" />{loading ? "Signing in..." : "Sign in"}
              </Button>
            </form>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
